export default {
	title: 'Configuración de Controlador de Salud del Dispositivo',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		statusUpdated: 'Estado actualizado a: {status}',
		updateFailed: 'Error al actualizar: {error}',
		unknownError: 'Error desconocido'
	},
	form: {
		projNo: 'Número de Proyecto',
		deviceNo: 'Número de Dispositivo',
		type: 'Tipo de Indicador'
	},
	table: {
		projNo: 'N° de Proyecto',
		deviceNo: 'N° de Dispositivo',
		deviceName: 'Nombre del Dispositivo',
		number: 'Número de Operadores de Salud'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		detailConfigTitle: 'Configuración Detallada'
	},
	detailConfig: {
		expandTitle: '{deviceNo} - {deviceName} - Configuración Detallada'
	},
	widgetForm: {
		projNo: 'Proyecto',
		deviceNo: 'Nombre del Dispositivo',
		pointNo: 'Nombre del Punto de Medición',
		indicatorType: 'Tipo de Indicador',
		type: 'Tipo de Dato',
		indicatorName: 'Nombre del Indicador',
		upperThreshold: 'Umbral Superior',
		lowerThreshold: 'Umbral Inferior',
		standardValue: 'Valor Estándar',
		weight: 'Peso',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			projNo: 'Por favor ingrese el proyecto',
			deviceNo: 'Por favor ingrese el nombre del dispositivo',
			pointNo: 'Por favor ingrese el nombre del punto de medición',
			indicatorType: 'Por favor seleccione el tipo de indicador',
			type: 'Por favor seleccione el tipo de dato',
			indicatorName: 'Por favor ingrese el nombre del indicador',
			upperThreshold: 'Por favor ingrese el umbral superior',
			lowerThreshold: 'Por favor ingrese el umbral inferior',
			standardValue: 'Por favor ingrese el valor estándar',
			weight: 'Por favor ingrese el peso'
		},
		options: {
			indicatorType: {
				reverse: 'Inverso',
				forward: 'Directo',
				standardValue: 'Valor Estándar'
			}
		}
	},
	expandTable: {
		projNo: 'N° de Proyecto',
		deviceNo: 'N° de Dispositivo',
		pointNo: 'N° de Punto de Medición',
		indicatorType: 'Tipo de Indicador',
		type: 'Tipo de Dato',
		indicatorName: 'Nombre del Indicador',
		isEnable: 'Habilitado',
		upperThreshold: 'Umbral Superior',
		lowerThreshold: 'Umbral Inferior',
		standardValue: 'Valor Estándar',
		weight: 'Peso',
		action: 'Acción',
		enable: 'Habilitar',
		disable: 'Deshabilitar'
	}
}
